import React from 'react'

function Tradizionale() {
    return (
        <div>
            <p className='info'>Il piano tradizionale è pensato per te che desideri pagare i consumi alla scadenza naturale della fattura.</p>
            <p className='info'>Non anticipi il pagamento e paghi il prezzo al kWh standard di listino senza bonus o sconti.</p>
            <div className="column">
                <div className="customRow">
                    <p className='main'>Cosa paghi?</p>
                    <span className="separ"></span>
                    <p className='secondary'>Prezzo al kWh tutto incluso x consumi mensili</p>
                </div>
                <div className="customRow">
                    <p className='main'>Hai sconti?</p>
                    <span className="separ"></span>
                    <p className='secondary'>Nessuno</p>
                </div>
                <div className="customRow">
                    <p className='main'>Quando paghi i consumi del mese?</p>
                    <span className="separ"></span>
                    <p className='secondary'>Tra il 15 e il 20 del mese successivo a quello dei consumi</p>
                </div>
            </div>
        </div>
    )
}

export default Tradizionale
